"use client";

import {
    Card,
    CardContent,
    CardHeader,
    CardTitle,
} from "@/components/shadcn/card";
import { Label } from "@/components/shadcn/label";
import { RadioGroup, RadioGroupItem } from "@/components/shadcn/radio-group";
import { Laptop, Moon, Sun } from "lucide-react";
import { useTranslations } from "next-intl";
import { useTheme } from "next-themes";
import { useEffect, useId, useState } from "react";

const themes = [
    { value: "system", icon: Laptop, labelKey: "themeSystem" },
    { value: "light", icon: Sun, labelKey: "themeLight" },
    { value: "dark", icon: Moon, labelKey: "themeDark" },
] as const;

export default function ThemeSettingsCard() {
    const t = useTranslations("account");
    const { theme, setTheme } = useTheme();
    const groupId = useId();

    // The stored theme is only known on the client, so render the options
    // unselected until mount to keep the server markup in sync.
    const [mounted, setMounted] = useState(false);
    useEffect(() => setMounted(true), []);

    return (
        <Card>
            <CardHeader>
                <CardTitle>{t("themeTitle")}</CardTitle>
            </CardHeader>
            <CardContent>
                <RadioGroup
                    value={mounted ? theme : undefined}
                    onValueChange={setTheme}
                    className="grid gap-4 sm:grid-cols-3"
                >
                    {themes.map(({ value, icon: Icon, labelKey }) => (
                        <Label
                            key={value}
                            htmlFor={`${groupId}-${value}`}
                            className="hover:bg-accent has-[[data-state=checked]]:border-primary flex cursor-pointer items-center gap-3 rounded-md border p-4 font-normal"
                        >
                            <RadioGroupItem
                                id={`${groupId}-${value}`}
                                value={value}
                            />
                            <Icon className="size-4" />
                            {t(labelKey)}
                        </Label>
                    ))}
                </RadioGroup>
            </CardContent>
        </Card>
    );
}
